<!-- 列表页表格 -->
<template>
    <el-table
        :data="tableObj.tableData"
        stripe
        style="width: 100%">
        <el-table-column
            v-for="(head,index) in tableObj.tableHead"
            :key="index"
            :prop="head.prop"
            :label="head.label"
            :align="head.align"
            :width="head.width?head.width*dpr:''">
            <template slot-scope="scope">
                <p
                    class="text_ellipsis"
                    :class="{'link':index==0}"
                    :title="scope.row[head.prop]"
                    @click="toDetail(scope.row.iAutoID)">
                    {{scope.row[head.prop]}}
                </p>
            </template>
        </el-table-column>
    </el-table>
</template>

<script>
import Util from '@/utils/Util';
import permission from "@/mixins/permission.js";
    export default {
        mixins:[permission],
        data() {
            return {
                dpr:Util.setDpr()
            }
        },
        props:{
            tableObj:{
                type:Object,
                default(){
                    return {
                        tableHead:[],
                        tableData:[],
                    };
                }
            },
        },
        created() {
            // console.log(this.tableObj.tableHead[0].width*this.dpr)
        },
        methods: {
            toDetail(id=0){
                let routeData = this.$router.resolve({
                    path: '/page/report/detail',
                    query:{
                        reportId:id,
                    }
                });
                window.open(routeData.href, this.isScreen?'_self':'_blank');
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>
